
export class CommonHelper {

    static intToGraphId(nodeName:string, value:number){
        return window.btoa(`${nodeName}:${value}`);
    }

    static getIdFromGraphId(graphId:string | number){
        if(typeof graphId ==='number'){
            return graphId;
          }
          let str = decodeURIComponent(escape(window.atob(graphId)));
          if (str.indexOf(":") != -1) {
            return parseInt(str.split(":")[1]);
          }
          return graphId;
    }

    static formatCurrency(value:number | string){
        if(typeof value === 'string'){
            value = parseFloat(value);
        }
        return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(value);
    }

}